import React from 'react';
import { Link } from 'react-router-dom';
import { AlertTriangle } from 'lucide-react';
import { Button } from './ui/button';
import { useFeatures } from '../context/FeatureContext';

// Phase 2 Task 4: in-app "past due / over your plan's limits" signal.
// Renders nothing when billing is healthy and usage is within limits.
export const BillingAlertBanner = () => {
  const { billing, overLimits } = useFeatures() || {};

  const pastDue = billing?.past_due;
  const overAny = overLimits?.any;
  if (!pastDue && !overAny) return null;

  let title;
  let body;
  if (pastDue && billing?.grace_expired) {
    title = 'Payment failed — this workspace is back on the Free plan';
    body = 'The grace period ended, so paid features are paused. Nothing was deleted — update your payment to restore everything instantly.';
  } else if (pastDue) {
    title = 'Payment failed — your plan stays active during a short grace period';
    body = 'We could not process your last subscription payment. Update your payment method to keep your paid features.';
  } else {
    const parts = [];
    if (overLimits?.films) parts.push('active films');
    if (overLimits?.seats) parts.push('team seats');
    title = `You're over your plan's ${parts.join(' and ')} limit`;
    body = 'Existing work is untouched, but new over-limit actions are blocked. Add an add-on or upgrade to lift the limit.';
  }

  return (
    <div
      className="mb-8 p-4 rounded-2xl border border-destructive/30 bg-destructive/10 flex items-center justify-between gap-4 flex-wrap"
      data-testid="billing-alert-banner"
    >
      <div className="flex items-center gap-3 min-w-0">
        <div className="size-9 rounded-xl bg-destructive/20 text-destructive flex items-center justify-center shrink-0">
          <AlertTriangle className="size-5" />
        </div>
        <div className="min-w-0">
          <p className="font-semibold text-foreground">{title}</p>
          <p className="text-sm text-muted-foreground">{body}</p>
        </div>
      </div>
      <Button asChild size="sm" className="rounded-xl" data-testid="billing-alert-cta">
        <Link to="/billing">Review billing</Link>
      </Button>
    </div>
  );
};

export default BillingAlertBanner;
